import { render, staticRenderFns } from "./application-header.vue?vue&type=template&id=52d4b4bf"
import script from "./application-header.vue?vue&type=script&lang=js"
export * from "./application-header.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports